import { courierService } from '@/services';

export const courierServiceModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      courier: null,
      error: null,
    },
  }),
  mutations: {
    load(state, courierKey) {
      courierService.getCourierServices(courierKey)
      .then((res) => {
        state.list.data = res
        state.list.courier = courierKey
      })
      .catch((error) => {
        state.list.data = null
        state.list.error = error
      });
    },
  }
}
